import { formSchema } from '../../validaciones/validacionPlatillos';
import { apiFetch } from '../../utils/api';

export const formularioPlatillosSlice = (set,get) => ({
    nivel_de_picante: [{value:0,label:"0"},{value:1,label:"1"},{value:2,label:"2"},{value:3,label:"3"}],
    estatus: [{value:1,label:"Activo"},{value:2,label:"No Disponible"},{value:3,label:"Oculto"}],
    obtenerCategoriaPlatillo: () => {
        fetch("/api/product-categories")
        .then((res) => res.json())
        .then((data) => {
            if(data.status){
                const categorias = Array.isArray(data.data) ? data.data : [];
                set({
                    categoriasPlatillo: categorias
                        .map((item) => ({
                            value: item.id || item.ID_CP || item.value,
                            label: item.nombre || item.name || item.NOMBRE_CP || item.label,
                        }))
                        .filter((item) => item.value && item.label),
                    isLoading: {...get().isLoading,cargarSucursalCategoria: false}
                })
            }
            else {
                set({ categoriasPlatillo: [], isLoading: {...get().isLoading,cargarSucursalCategoria: false} })
            }
        })
        .catch((error) => {
            console.error('Error al cargar categorías de merch:', error);
            set({ categoriasPlatillo: [], isLoading: {...get().isLoading,cargarSucursalCategoria: false} })
        });
    },
    handleChange: (e) => set({ datos:{ ...get().datos, [e.target.name]: e.target.value } }),
    handleSave: async () => {

        const result = formSchema.safeParse({ ...get().datos, multiImagenes: get().multiImagenes, sucursalesPlatillo: get().sucursalesPlatillo });
        if (!result.success) {
            console.log(result.error.errors);
            console.log(result.error.flatten().fieldErrors);
            set({error:result.error.flatten().fieldErrors})
            return;
        }
        else{
            set({error:null})
        }

        const sucursalSeleccionada = get().sucursalesPlatillo;
        const datos = get().datos;
        const payload = {
            branchId: sucursalSeleccionada?.value || sucursalSeleccionada?.[0]?.value,
            categoryId: datos.id_cp || null,
            nombre: datos.nombre,
            descripcion: datos.descripcion || null,
            precio: Number(datos.precio),
            stock: 0,
            activo: Number(datos.estatus) === 1,
        };

        const subirImagenes = async (productId) => {
            const imagenesNuevas = get().multiImagenes.filter((imagen) => imagen.esNuevo && imagen.file);
            if (imagenesNuevas.length === 0) return;

            const formData = new FormData();
            imagenesNuevas.forEach((imagen) => {
                formData.append('imagenes', imagen.file);
            });

            await fetch(`/api/products/${productId}/images`, {
                method: "POST",
                body: formData
            }).then((res) => res.json());
        };

        const eliminarImagenesRemovidas = async () => {
            const imagenesActualesIds = new Set(
                get().multiImagenes
                    .filter((imagen) => !imagen.esNuevo && imagen.id)
                    .map((imagen) => String(imagen.id))
            );
            const removidas = (get().imagenesOriginales || [])
                .filter((imagen) => imagen.id && !imagenesActualesIds.has(String(imagen.id)));

            for (const imagen of removidas) {
                await apiFetch(`/api/products/images/${imagen.id}`, { method: "DELETE" });
            }
        };

        if (get().datos.id == 0) {
          try {
            fetch("/api/products",{
            method: "POST",
            headers:{
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload)
            })
            .then((res) => res.json())
            .then(async (data) => {
              console.log(data);
              if(data.status){
                  await subirImagenes(data.data.id);
                  // Success
                  get().elNavigate(-1);
              }
              });
          } catch (error) {
              console.error('Error:', error);
          }
        }
        else {
            console.log('Entrando actualizar');
          
          try {
            fetch(`/api/products/${get().datos.id}`,{
              method: "PUT",
              headers:{
                  "Content-Type": "application/json",
              },
              body: JSON.stringify(payload)
              })
              .then((res) => res.json())
              .then(async (data) => {
              console.log(data);
              if(data.status){
                  await eliminarImagenesRemovidas();
                  await subirImagenes(get().datos.id);
                  // Success
                  get().elNavigate(-1);
              }
            });
          } catch (error) {
              console.error('Error:', error);
          }
        }
    },
    obtenerPlatillo: () => {
        if(get().datos.id != 0){
            fetch(`/api/products/${get().datos.id}`,{
                method: "GET",
                headers:{
                "Content-Type": "application/json",
                },
            })
            .then((res) => res.json())
            .then(async (data) => {
                    console.log('MERCH',data);
                if(data.status){
                    set({datos:{
                        ...get().datos,
                        id_cp:data.data.categoryId?.toString(),
                        nombre:data.data.nombre,
                        descripcion:data.data.descripcion || "",
                        precio:data.data.precio?.toString() || "",
                        nivel_picante:"0",
                        tiempo:"",
                        es_nuevo:false,
                        estatus:data.data.activo ? 1 : 3
                    }});
                    if (data.data.tienda?.branch) {
                        set({sucursalesPlatillo:{ value: data.data.tienda.branch.id, label: data.data.tienda.branch.nombre }});
                    }

                    let imagenesMerch = []
                    const imagenes = Array.isArray(data.data.imagenes) ? data.data.imagenes : [];
                    for(let i = 0; i < imagenes.length; i++){
                        imagenesMerch.push({
                            id:imagenes[i].id,
                            nombre:imagenes[i].imageKey || imagenes[i].imageUrl,
                            file:null,
                            esNuevo:false,
                            preview:imagenes[i].imageUrl,
                        })
                    }

                    console.log('imagenesMerch',imagenesMerch);

                    set({multiImagenes:imagenesMerch, imagenesOriginales:imagenesMerch});

                    set({isLoading:{...get().isLoading,cargarPlatillo:false}});
                }
            });
        }
        else{
            set({isLoading:{...get().isLoading,cargarPlatillo:false}});
        }
    },
})
